var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeaderOpenBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.40737 13.9374C4.70144 13.1905 3.40724 11.7411 3.50472 10.7125C10.5304 7.46391 18.5713 6.97509 26.1583 7.94255C26.8273 8.10209 28.9686 11.0112 28.4072 11.4491C27.1399 11.2998 25.8726 11.1606 24.5986 11.0757C19.4251 10.811 14.1676 11.2794 9.21267 12.8613C8.07982 13.2279 6.98731 13.6794 5.91497 14.1886C5.73344 14.2666 5.5183 14.0256 5.41073 13.9374H5.40737Z",
    fill: "#213A68"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.95802 24.2344C7.23865 23.4638 5.97134 22.0687 6.05201 21.0096C12.244 18.002 19.3974 17.839 26.0466 19.1256C26.7122 19.2885 28.8569 22.1943 28.2922 22.6322C25.8752 22.2282 23.4347 21.8752 20.9807 21.8412C16.7015 21.8412 12.3348 22.6084 8.46226 24.4856C8.28074 24.5671 8.05887 24.3193 7.95802 24.2344Z",
    fill: "#213A68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderOpenBlue);
export default __webpack_public_path__ + "static/media/HeaderOpenBlue.05857c22db4926d6671781ab7d9f3cc4.svg";
export { ForwardRef as ReactComponent };